import { PayCycle, PayFrequency } from '@aslanpay/portal-common-lib';
import { format, parseISO } from 'date-fns';

export const parseCurrencyIntoFloat = (currencyString: string): number =>
  parseFloat(currencyString?.replace(/[^\d.-]/g, ''));

export const getInitials = (value: string) =>
  value
    ?.match(/(\b\S)?/g)
    ?.join('')
    .match(/(^\S|\S$)?/g)
    ?.join('')
    .toUpperCase();

export const toKebabCase = (text: string) => {
  return text.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

export const toHumanReadable = (text: string) => {
  const result = text.replace(/([a-z])([A-Z])/g, '$1 $2');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const getCurrencySymbol = (currencyCode: string): string => {
  const formatter = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const parts = formatter.formatToParts(0);
  const symbolPart = parts.find((p) => p.type === 'currency');
  return symbolPart?.value || currencyCode;
};

export const formatCurrency = (value: number, currency = 'GBP', locale = 'en-US') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency !== '' ? currency : 'GBP',
    currencyDisplay: 'symbol',
  }).format(value);
};

export const getPayCycleName = (payCycle: PayCycle | undefined, frequency: PayFrequency) => {
  if (!payCycle) {
    return '';
  }
  if (frequency === 'MONTHLY') {
    return format(parseISO(payCycle.startDate as string), 'MMMM yyyy');
  }

  return `${format(parseISO(payCycle.startDate as string), 'd MMM yy')} - ${format(
    parseISO(payCycle.endDate as string),
    'd MMM yy'
  )}`;
};
